import { render, staticRenderFns } from "./AccountStatementView.vue?vue&type=template&id=4faaa80e&"
import script from "./AccountStatementView.vue?vue&type=script&lang=js&"
export * from "./AccountStatementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports